import type { State, Action } from './types/errorReport.d';
import * as types from './types';

const initialState: State = {
  loading: false,
  error: '',
  report: null,
};

const errorReportReducers = (state = initialState, { type, payload }: Action): State => {
  switch (type) {
    case types.GET_ERROR_REPORT.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case types.GET_ERROR_REPORT.SUCCESS:
      return {
        ...state,
        report: payload.response,
        loading: false,
        error: '',
      };

    case types.GET_ERROR_REPORT.CANCEL:
    case types.GET_ERROR_REPORT.FAILURE:
      return {
        ...state,
        loading: false,
        error: payload.message,
      };

    default:
      return state;
  }
};

export default errorReportReducers;
export { initialState };
